module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="background">\n	<div class="status '+
((__t=( status ))==null?'':__t)+
'">\n		Authenticating...\n	</div>\n</div>';
}
return __p;
};
